export default "__VITE_ASSET__BfI5OzyE__"